export type TSpellInfo = {
  id: number;
  school: number;
  icon: string;
  name: string;
  description?: string;
  rank: null | number;
  hasCooldown?: boolean;
};

export type TGetSpellsParams = {
  search: string;
  limit: number;
  page: number;

  slugs?: string[];
};

export type TGetSpellsListResponse = {
  data: TSpellInfo[];
};

export enum SpellCategory {
  Bloodlust = 'bloodlust'
  // Defensive = 'defensive',
  // Offensive = 'offensive'
}
